type PressureSource = 'cpu' | 'gpu';
type PressureState = '' | 'nominal' | 'fair' | 'serious' | 'critical';

interface PressureUpdateCallback {
  (changes: PressureRecord[], observer: PressureObserver): void;
}
interface PressureObserverOptions {
  sampleInterval: number;
}
interface PressureObserver {
  observe(source: PressureSource, options: PressureObserverOptions): Promise<undefined>;
  unobserve(source: PressureSource): void;
  disconnect(): void;
  takeRecords(): PressureRecord[];
}
declare const PressureObserver: {
  prototype: PressureObserver;
  new (callback: PressureUpdateCallback): PressureObserver;
};
interface PressureRecord {
  readonly source: PressureSource;
  readonly state: PressureState;
  readonly time: DOMHighResTimeStamp;
}

export class PressureStateTracker {
  public pressure: PressureState = '';
  private observer: PressureObserver | undefined = undefined;
  constructor(private source: PressureSource) {
    if (!('PressureObserver' in window)) {
      return;
    }

    this.observer = new (window.PressureObserver as typeof PressureObserver)((records) => {
      const lastRecord = records.at(-1);
      if (!lastRecord) {
        return;
      }
      this.pressure = lastRecord.state;
    });
    this.observer
      .observe(source, {
        sampleInterval: 1000,
      })
      .catch(() => {
        // observe() rejects with an AbortError if destroy() runs disconnect()
        // before the registration settles. The abort is expected on teardown.
      });
  }
  destroy() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = undefined;
    }
  }
}
